import { getGenentechSpecificSections } from "./Genentech/freeDrug/genentechPapFieldsConfiguration";
import { getGenentechCopaySpecificSections } from "./Genentech/copay/genentechCopayFieldsConfiguration";
import { getNovartisSpecificSections } from "./Novartis/copay/novartisCopayFieldsConfiguration";

export const vendors = {
  GENENTECH_PAP: "genentech_pap",
  GENENTECH_COPAY: "genentech_copay",
  NOVARTIS_COPAY: "novartis_copay"
};

export const formSectionsController = () => {
  const configurations = {
    [vendors.GENENTECH_PAP]: () => getGenentechSpecificSections(),
    [vendors.GENENTECH_COPAY]: () => getGenentechCopaySpecificSections(),
    [vendors.NOVARTIS_COPAY]: () => getNovartisSpecificSections()
  };

  return {
    getSectionFieldsByVendor: (vendor) => configurations[vendor]
  };
};
